import {
  GET_INVOICE,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_ERROR,

  GET_INVOICE_LINEITEMS,
  GET_INVOICE_LINEITEMS_SUCCESS,
  GET_INVOICE_LINEITEMS_ERROR,  

  GET_INVOICE_BILLINGCONTACT,
  GET_INVOICE_BILLINGCONTACT_SUCCESS,
  GET_INVOICE_BILLINGCONTACT_ERROR,  
} from "../actions";

export const getInvoice = (invoiceId, activityInfo) => ({
    type: GET_INVOICE,
    payload: { invoiceId, activityInfo},
  });

export const getInvoiceSuccess = (invoice) => ({
  type: GET_INVOICE_SUCCESS,
  payload: invoice,
});

export const getInvoiceError = (message) => ({
  type: GET_INVOICE_ERROR,
  payload: { message },
});

export const getRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, invoiceId, hasUserAccount, profile, params, searchInputName, activityInfo) => ({
  type: GET_INVOICE_LINEITEMS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, invoiceId, hasUserAccount, profile, params, searchInputName, activityInfo },
});

export const getRecordsSuccess = (recordList) => ({
  type: GET_INVOICE_LINEITEMS_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_INVOICE_LINEITEMS_ERROR,
  payload: { message },
});

export const getInvoiceBillingContact = (billingContactId, activityInfo) => ({
  type: GET_INVOICE_BILLINGCONTACT,
  payload: { billingContactId, activityInfo },
});

export const getInvoiceBillingContactSuccess = (billingContact) => ({
  type:GET_INVOICE_BILLINGCONTACT_SUCCESS,
  payload: billingContact,
});

export const getInvoiceBillingContactError = (message) => ({
  type:GET_INVOICE_BILLINGCONTACT_ERROR,
  payload: { message },
});